import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=c3588bea&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3588bea')) {
      api.createRecord('c3588bea', component.options)
    } else {
      api.reload('c3588bea', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=c3588bea&", function () {
      api.rerender('c3588bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GvZ9dS5za3fH/JS/offershelp.vue"
export default component.exports